var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswerX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04585 5.1057C3.08613 5.04099 3.08613 4.95901 3.04585 4.8943L0.189328 0.305697C0.106394 0.172475 0.202189 0 0.359116 0H1.66135C1.73116 0 1.79592 0.0364009 1.8322 0.0960389L3.82817 3.37634C3.90608 3.5044 4.09197 3.5044 4.16988 3.37634L6.16584 0.0960386C6.20213 0.0364006 6.26689 0 6.3367 0H7.63893C7.79586 0 7.89165 0.172476 7.80872 0.305698L4.9522 4.8943C4.91191 4.95901 4.91191 5.04099 4.9522 5.1057L7.80872 9.6943C7.89165 9.82752 7.79586 10 7.63893 10H6.33647C6.26678 10 6.20212 9.96373 6.1658 9.90426L4.1697 6.63655C4.09172 6.50889 3.90633 6.50889 3.82835 6.63655L1.83225 9.90426C1.79593 9.96373 1.73126 10 1.66158 10H0.359116C0.202189 10 0.106394 9.82752 0.189328 9.6943L3.04585 5.1057Z",
    fill: "#22CE29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerX);
export default __webpack_public_path__ + "static/media/answer_x.b5a08b47e36d7d3d5aea55ae11cbda0a.svg";
export { ForwardRef as ReactComponent };